module.exports = __webpack_public_path__ + "static/media/krizova-chodba-kriz.0268cd2d.jpg";